module.exports = __webpack_public_path__ + "img/chroma-free-trial.a45f5805.png";